import { COLOR } from 'app-v2/design-tokens'
import { Chevron } from 'app/assets/icons'
import { Text } from 'app/common/typography'
import type { Element } from 'react'
import React, { Fragment } from 'react'

type Props = {
    label: string,
    children?: Element<any>,
    collapsed: boolean
}

const DropdownButton = (props: Props) => {
    const { label, children, collapsed } = props
    return (
        <Fragment>
            <Text>{label}</Text>
            <Chevron
                direction={collapsed ? 'up' : 'down'}
                color={COLOR.PRIMARY}
            />
            {children}
        </Fragment>
    )
}

export { DropdownButton }
